// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"124":"a3f64b3a","135":"ba0dbc68","447":"ae21e012"}[chunkId] + ".js";
};